var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_290_90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1667 0H1.83335C0.822422 0 0 0.822422 0 1.83335V15.0333C0 16.0442 0.822422 16.8667 1.83335 16.8667H20.1667C21.1776 16.8667 22 16.0443 22 15.0333V1.83335C22 0.822422 21.1776 0 20.1667 0Z",
    fill: "#EBEBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.1 15.0333V1.83335C1.1 0.822422 1.92242 0 2.93335 0H1.83335C0.822422 0 0 0.822422 0 1.83335V15.0333C0 16.0442 0.822422 16.8667 1.83335 16.8667H2.93335C1.92242 16.8667 1.1 16.0442 1.1 15.0333Z",
    fill: "#D7D8D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9272 20.4677L13.1938 16.4344C13.1622 16.26 13.0103 16.1333 12.8331 16.1333H9.16643C8.98922 16.1333 8.83737 16.26 8.80566 16.4344L8.07231 20.4677C8.05289 20.5747 8.08189 20.6848 8.15155 20.7683C8.2212 20.8517 8.32432 20.9 8.43304 20.9H13.5664C13.6751 20.9 13.7782 20.8517 13.8479 20.7683C13.9176 20.6848 13.9466 20.5747 13.9272 20.4677Z",
    fill: "#6AC8B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1939 16.4344C13.1622 16.26 13.0103 16.1333 12.8331 16.1333H9.16644C8.98923 16.1333 8.83738 16.26 8.80567 16.4344L8.59375 17.6H13.4058L13.1939 16.4344Z",
    fill: "#2DB59F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2996 20.1666H7.69961C7.09311 20.1666 6.59961 20.6601 6.59961 21.2666V21.6333C6.59961 21.8358 6.76379 21.9999 6.96626 21.9999H15.0329C15.2354 21.9999 15.3996 21.8357 15.3996 21.6333V21.2666C15.3996 20.6601 14.9061 20.1666 14.2996 20.1666Z",
    fill: "#74DBC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33296 21.6334V21.2667C7.33296 20.6602 7.82645 20.1667 8.43296 20.1667H7.69961C7.09311 20.1667 6.59961 20.6602 6.59961 21.2667V21.6334C6.59961 21.8359 6.76379 22.0001 6.96626 22.0001H7.69961C7.4971 22.0001 7.33296 21.8359 7.33296 21.6334Z",
    fill: "#6AC8B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 1.83335C22 0.822422 21.1776 0 20.1667 0H1.83335C0.822422 0 0 0.822422 0 1.83335V2.2H22V1.83335Z",
    fill: "#6AC8B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.83335 16.8667H20.1667C21.1776 16.8667 22 16.0443 22 15.0333H0C0 16.0443 0.822422 16.8667 1.83335 16.8667Z",
    fill: "#6AC8B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.93335 0H1.83335C0.822422 0 0 0.822422 0 1.83335V2.2H1.1V1.83335C1.1 0.822422 1.92242 0 2.93335 0Z",
    fill: "#2DB59F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.1 15.0333H0C0 16.0442 0.822422 16.8667 1.83335 16.8667H2.93335C1.92242 16.8666 1.1 16.0442 1.1 15.0333Z",
    fill: "#2DB59F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4995 13.9334H5.49946C5.29695 13.9334 5.13281 13.7692 5.13281 13.5667C5.13281 13.3642 5.297 13.2001 5.49946 13.2001H16.4995C17.3082 13.2001 17.9661 12.5422 17.9661 11.7334C17.9661 10.9247 17.3082 10.2667 16.4995 10.2667H11.3661C10.1531 10.2667 9.16612 9.27975 9.16612 8.0667C9.16612 6.85365 10.1531 5.8667 11.3661 5.8667H17.9661C18.1686 5.8667 18.3328 6.03088 18.3328 6.23335C18.3328 6.43586 18.1686 6.6 17.9661 6.6H11.3661C10.5574 6.6 9.89946 7.25794 9.89946 8.06666C9.89946 8.87537 10.5574 9.53331 11.3661 9.53331H16.4995C17.7125 9.53331 18.6995 10.5203 18.6995 11.7333C18.6995 12.9464 17.7126 13.9334 16.4995 13.9334Z",
    fill: "#606268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49922 5.1333C3.67958 5.1333 2.19922 6.61366 2.19922 8.4333C2.19922 10.1371 4.90879 13.4316 5.21777 13.8016C5.28743 13.885 5.39055 13.9333 5.49922 13.9333C5.60789 13.9333 5.71101 13.8851 5.78066 13.8016C6.08961 13.4316 8.79922 10.1371 8.79922 8.4333C8.79922 6.61366 7.31886 5.1333 5.49922 5.1333Z",
    fill: "#E5563C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.93252 8.8C2.93252 6.98036 4.41288 5.5 6.23252 5.5C6.61598 5.5 6.98405 5.56647 7.32672 5.68721C6.80311 5.33766 6.17464 5.1333 5.49922 5.1333C3.67958 5.1333 2.19922 6.61366 2.19922 8.4333C2.19922 10.1371 4.90879 13.4316 5.21777 13.8016C5.28743 13.885 5.39055 13.9333 5.49922 13.9333C5.57407 13.9333 5.64591 13.91 5.70637 13.8685C4.9585 12.936 2.93252 10.2734 2.93252 8.8Z",
    fill: "#CF442B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.50078 10.6334C6.71581 10.6334 7.70078 9.64842 7.70078 8.4334C7.70078 7.21837 6.71581 6.2334 5.50078 6.2334C4.28575 6.2334 3.30078 7.21837 3.30078 8.4334C3.30078 9.64842 4.28575 10.6334 5.50078 10.6334Z",
    fill: "#EBEBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49986 9.89998C6.30987 9.89998 6.96651 9.24334 6.96651 8.43333C6.96651 7.62332 6.30987 6.96667 5.49986 6.96667C4.68985 6.96667 4.0332 7.62332 4.0332 8.43333C4.0332 9.24334 4.68985 9.89998 5.49986 9.89998Z",
    fill: "#D7D8D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0667 4.03333H16.8667C16.6641 4.03333 16.5 4.19751 16.5 4.39998V6.23333C16.5 6.43584 16.6642 6.59998 16.8667 6.59998H19.0667C19.2692 6.59998 19.4333 6.43579 19.4333 6.23333V4.39998C19.4333 4.19747 19.2692 4.03333 19.0667 4.03333Z",
    fill: "#FDD042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 4.7667V4.18529L18.9593 3.55937C19.1024 3.41615 19.1024 3.18403 18.9593 3.04082C18.8161 2.89769 18.5839 2.89769 18.4407 3.04082L17.9667 3.51494L17.4926 3.04082C17.3494 2.89769 17.1172 2.89769 16.974 3.04082C16.8309 3.18403 16.8309 3.41615 16.974 3.55937L17.6 4.18529V4.76674H16.5V5.50005H17.6V6.60005H18.3333V5.50005H19.4333V4.7667H18.3333Z",
    fill: "#F07B52"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_290_90"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.1f692d9aba94a1585083bca1fe874fe8.svg";
export { ForwardRef as ReactComponent };